import initDatePicker from "./calender-plugin";
import filterSelector from "./filter-selector";
import setShadowRootStyles from "./functions/setShadowRoot";

$(document).ready(function () {
    let DEBUG = checkForDebug();
    if (DEBUG) { console.debug("Debug controls: ", this) }

    /* reset form on load */
    if ($("form[method='post']")[0]) {
        $("form[method='post']")[0].reset();
    }

    if (".filter") {
        var query = ".filter-popup input.form-check-input";
        new filterSelector(query);
    }

    /* hide endDate - if not set / or no load */
    if ($(".filter-calender")) {
        $(".filter-calender").addClass("clear");
        try {
            if ($(".filter-calender #startDate")[0].value != "") {
                $(".filter-calender").removeClass("clear");
            }
        } catch (error) { }
        $(".filter-calender").click(function () {
            $(".filter-calender").removeClass("clear");
        })
    }

    /*
        open filter - display filter-popups
        - hides header by setting zindex lower
        - removes the function to scroll the page when filter is open
    */
    $(".filter-category > .btn").click(function (e) {
        if (e.currentTarget.classList.contains("btn")) {
            /*console.log(e);*/
            var filter_control = e.currentTarget;
            content = filter_control.nextElementSibling;
            if (content && content.classList.contains("filter-popup")) {
                if (content.classList.contains("hidden")) {
                    content.classList.remove("hidden");
                    hideControls();
                    toggleBodyOverflow();
                } else {
                    content.classList.add("hidden");
                    showControls();
                    toggleBodyOverflow();
                }
            }
        }
    });

    /* show more description text - in detail views */
    if (document.querySelector("#description-text-button")) {
        $("#description-text-button").click(function (e) {
            var txt = $("#description-text");
            var btn = $("#description-text-button");
            if (txt[0].classList.contains("collapsed")) {
                txt[0].classList.remove("collapsed");
                btn[0].classList.remove("shown");
            } else {
                /*console.error("failed to remove class at ", e);*/
            }
        });
    }

    /* hide the description overflow - if text is too small */
    if (document.querySelector("#description-text")) {
        if ($("#description-text")[0].offsetHeight < 200) {
            $("#description-text")[0].classList.remove("collapsed");
            $("#description-text-button")[0].classList.remove("shown");
        }
    }

    /* close popup */
    $(".btn-close").click(function () {
        var elem = this.parentElement.parentElement;
        if (elem.classList.contains("popup")) {
            elem.classList.add("hidden");
            showControls();
            toggleBodyOverflow(true);
        }
    });

    /* Detail view swiper thumbnails */
    $(function () {
        var galleryThumbs = new Swiper(".gallery-thumbs", {
            centeredSlides: true,
            centeredSlidesBounds: true,
            direction: "horizontal",
            spaceBetween: 10,
            slidesPerView: 3,
            freeMode: false,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
            watchOverflow: true,
            breakpoints: {
                480: {
                    direction: "vertical",
                    slidesPerView: 3
                }
            }
        });
        var galleryTop = new Swiper(".gallery-top", {
            direction: "horizontal",
            spaceBetween: 10,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev"
            },
            a11y: {
                prevSlideMessage: "Previous slide",
                nextSlideMessage: "Next slide",
            },
            keyboard: {
                enabled: true,
            },
            thumbs: {
                swiper: galleryThumbs
            }
        });
        galleryTop.on("slideChangeTransitionStart", function () {
            galleryThumbs.slideTo(galleryTop.activeIndex);
        });
        galleryThumbs.on("transitionStart", function () {
            galleryTop.slideTo(galleryThumbs.activeIndex);
        });
    });

    if($(".thumbs")) {checkThumbs()}
});
/* keypress "ESC" => close search */
$(document).on("keypress", function (e) {
    let DEBUG = checkForDebug();
    if (e.which === 27 || e.which === 13) {
        var search = document.querySelector("#searchfield-main");
        if (!search.classList.contains("hidden")) {
            search.classList.add("hidden");
        }
    } else if (DEBUG) {
        console.log(e.which)
    }
});

/**
 * checks for local DDEV environment by hostname
 * @returns {number} debug - 1 = true, 0 = false
 */
function checkForDebug() {
    var debug = undefined;
    if (window.location.hostname === "typo3.2024.ferienregion-nationalpark.de.ddev.site") { debug = 1 } else { debug = 0 }
    if (debug) { console.log("local DDEV env detected --- running with active DEBUG option..") }
    return debug;
}

/*
    adds class "overflow-hidden" to body, if popup is open
    else, removes "overflow-hidden" from body
*/
function toggleBodyOverflow(force) {
    var body = document.querySelector("body");
    if (body.classList.contains("overflow-hidden") || force) {
        body.classList.remove("overflow-hidden");
    } else {
        body.classList.add("overflow-hidden");
    }
}

/**
 * hides header and mobile menu by setting zindex lower
 */
function hideControls() {
    var header = document.querySelector("#header"),
        menuMobile = document.querySelector("#menuMobile");
    if (header) {
        header.style.zIndex = "700";
    }
    if (menuMobile) {
        menuMobile.style.zIndex = "700";
    }
}

/**
 * shows header and mobile menu by resetting zindex
 */
function showControls() {
    var header = document.querySelector("#header"),
        menuMobile = document.querySelector("#menuMobile");
    if (header) {
        header.style.zIndex = "";
    }
    if (menuMobile) {
        menuMobile.style.zIndex = "";
    }
}

/**
 * checks for thumbs column - if found, check if thumbs are loaded and visible - if not, hide the column
 */
function checkThumbs() {
    if(document.querySelector(".images .thumbs")) {
        let thumbs = $(".images .thumbs");
        let main = $(".images .main");
        if(thumbs[0].children.length < 1) {
            thumbs[0].classList.add("hidden");
            main[0].classList.remove("col-10");
            main[0].classList.add("col-12");
        }
    }
}
